import {
  LanguageCodes,
  LANGUAGE_CODE_EN_AU,
  LANGUAGE_CODE_EN_US,
} from 'global/constants';

/**
 * Checks if the given language is English (en-US or en-AU).
 *
 * @param language - The language code to check, or undefined (treated as English)
 * @returns true if language is English or undefined, false otherwise
 */
export const isEnglishLanguage = (language?: LanguageCodes): boolean => {
  return (
    !language ||
    language === LANGUAGE_CODE_EN_US ||
    language === LANGUAGE_CODE_EN_AU
  );
};

/**
 * Determines whether text should be scaled for translation based on language and content type.
 *
 * @param language - The current display language
 * @returns true if text should be scaled down to fit original bounds
 */
export const shouldScaleTextForTranslation = (
  language?: LanguageCodes
): boolean => {
  return !isEnglishLanguage(language);
};
